"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOutDateClick = void 0;
const react_1 = require("react");
const useOutDateClick = (callback) => {
    const rootRef = (0, react_1.useRef)(null);
    const handleOutsideClickRef = (0, react_1.useRef)((_) => { });
    handleOutsideClickRef.current = (event) => {
        var _a;
        const target = event.target;
        if ((_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))
            return;
        callback();
    };
    (0, react_1.useEffect)(() => {
        const handle = (event) => handleOutsideClickRef.current(event);
        document.addEventListener('click', handle);
        return () => document.removeEventListener('click', handle);
    }, []);
    return { rootRef };
};
exports.useOutDateClick = useOutDateClick;
//# sourceMappingURL=useOutDateClick.js.map